import { render, staticRenderFns } from "./FdInput.vue?vue&type=template&id=4534a3a8&scoped=true"
import script from "./FdInput.vue?vue&type=script&lang=js"
export * from "./FdInput.vue?vue&type=script&lang=js"
import style0 from "./FdInput.vue?vue&type=style&index=0&id=4534a3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4534a3a8",
  null
  
)

export default component.exports